import React, { useEffect, useState } from "react";
import useLocales from "../../../../hooks/useLocales";
const QrImageCard = ({ item, styles }) => {
  const { translate } = useLocales();
  const coloum_value = JSON.parse(item?.coloum_value);

  const [fonts, setFonts] = useState(styles?.filter((item) => item.coloum_name === "fonts")?.[0]);
  const [fontValue, setFontValue] = useState(null);
  
  useEffect(() => {
    setFonts(styles?.filter((item) => item.coloum_name === "fonts")?.[0]);
  }, [item, styles])

  useEffect(() => {
    if(fonts?.coloum_value){
      setFontValue(JSON.parse(fonts?.coloum_value));
    }
  }, [fonts])


  return (
    <div className="bg-white m-0 rounded-[16px] flex flex-col items-center">
      <img
        src={coloum_value?.qr}
        className="m-0 rounded-[16px] w-[139px] max-w-[139px] min-w-[139px] h-[139px] max-h-[139px] min-h-[139px]"
        alt="qrCode" title="QR Code"
      />
      <div className="p-[15px] pt-0">
        <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={` text-small3 text-center font-${fontValue?.fontType?.value}`}>
        {/* Scan QR Code */}{translate("cms.scan_qr_code")}
        </p>
      </div>
    </div>
  );
};

export default QrImageCard;
